module.exports = __webpack_public_path__ + "static/media/icon_handicap.50fdc8e4.png";